export const sizeIsSelected = state => {
  return state.selectedSizeLabel;
};

export const inseamIsSelected = state => {
  return (
    (!state.fallbackInseamLabel && !state.inseamOptions?.length) ||
    state.selectedInseamLabel
  );
};

export const allowClick = state => {
  return sizeIsSelected(state) && inseamIsSelected(state);
};

export const unselectedStateMessage = state => {
  const unselectedSizeMessage = 'Please choose a size first';

  const unselectInseamMessage = 'Please choose an inseam first';

  const unselectSizeAndInseamMessage = 'Please choose a size and inseam first';

  if (!sizeIsSelected(state) && inseamIsSelected(state)) {
    return unselectedSizeMessage;
  }

  if (sizeIsSelected(state) && !inseamIsSelected(state)) {
    return unselectInseamMessage;
  }

  if (!sizeIsSelected(state) && !inseamIsSelected(state)) {
    return unselectSizeAndInseamMessage;
  }

  return '';
};
